import { __assign } from "tslib";
import React from 'react';
import { View, ActivityIndicator, TouchableHighlight } from 'react-native';
// Custom
import c, { globalStyles } from '../styles/_colors.js';
var CardComponent = function (props) {
  if (props.onPress) {
    return /*#__PURE__*/React.createElement(TouchableHighlight, __assign({
      underlayColor: c.buttonActive
    }, props, {
      style: [s.card(props), props.style]
    }), /*#__PURE__*/React.createElement(View, null, props.children));
  } else {
    return /*#__PURE__*/React.createElement(View, {
      style: [s.card(props), props.style]
    }, props.children);
  }
};
var LoadingOverlay = function (props) {
  return /*#__PURE__*/React.createElement(View, {
    style: s.overlay
  }, /*#__PURE__*/React.createElement(ActivityIndicator, {
    color: c.gray,
    animating: true
  }));
};
var PnmacMobileCard = function (props) {
  return /*#__PURE__*/React.createElement(CardComponent, __assign({}, props), /*#__PURE__*/React.createElement(View, {
    style: props.contentContainerStyle
  }, props.children, props.loading && /*#__PURE__*/React.createElement(LoadingOverlay, null)));
};
export default PnmacMobileCard;
var s = {
  card: function (props) {
    return {
      backgroundColor: c.white,
      borderRadius: 10,
      marginHorizontal: globalStyles.marginHorizontal,
      paddingVertical: props.noPadding ? 0 : 15,
      paddingHorizontal: props.noPadding ? 0 : 20
    };
  },
  overlay: {
    position: 'absolute',
    backgroundColor: c.transparentWhite,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    alignItems: 'center',
    justifyContent: 'center'
  }
};